export default function ServiceHero() {
  return (
    <section className="relative h-64 sm:h-80 md:h-96 bg-cover bg-center" style={{
      backgroundImage: `url('https://public.readdy.ai/ai/img_res/4355c436af73b7b0bdffd17db87227c1.jpg')`
    }}>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      <div className="relative z-10 h-full flex items-center">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            サービス内容
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-2xl">
            岡山市・倉敷市を中心に、<br className="sm:hidden" />住宅リフォーム・店舗工事・修繕工事を<br className="sm:hidden" />幅広く対応
          </p>
        </div>
      </div>
    </section>
  );
}
